import { eventTypes } from "@/shared/selectors/EventTypeSelector";
import { Tooltip } from "@mui/material";

type EventTagProps = {
	event: { Code: string; Name: string };
	show?: "name" | "code";
};

export const EventTypeTag = ({ event, show = "code" }: EventTagProps) => {
	if (!event || !event.Code || !event.Name) {
		return null;
	}
	var backgroundColor = eventTypes.find(
		(e) => e.code === event.Code,
	)?.borderColor;

	if (show === "code") {
		return (
			<Tooltip title={event.Name} arrow>
				<div
					style={{
						width: "26px",
						height: "26px",
						borderRadius: 4,
						display: "inline-flex",
						alignItems: "center",
						justifyContent: "center",
						color: "#fff",
						fontWeight: "bold",
						backgroundColor,
					}}
				>
					{event.Code.charAt(0).toUpperCase()}
				</div>
			</Tooltip>
		);
	}

	var borderColor = eventTypes.find((e) => e.code === event.Code)?.borderColor;

	return (
		<div
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: "6px",
				fontSize: "0.875rem",
			}}
		>
			<div
				style={{
					width: 8,
					height: 8,
					borderRadius: "50%",
					backgroundColor: borderColor,
					flexShrink: 0,
				}}
			/>
			<span style={{ fontWeight: 500 }}>{event.Name}</span>
		</div>
	);
};
